// @flow
import * as React from 'react';
import type { ChildrenArray, Element } from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { Text } from '../Text.js';
import { Heading } from '../Heading.js';
import { productColor } from '../designSystem.js';

export function TSOLessonNarrative(props: {|
  children: ChildrenArray<Element<typeof Text>>,
|}) {
  const { failedValidation } = usePropsValidation(props, TSOLessonNarrative);

  if (failedValidation) return null;

  return (
    <div style={{ color: productColor.shuttleGrey }}>
      <Heading>Lesson narrative</Heading>
      <div style={{ fontFamily: 'Proxima Nova' }}>{props.children}</div>
    </div>
  );
}
TSOLessonNarrative.spec = {
  children: t.childrenArray(t.elementType(Text)),
};
